module.exports = __webpack_public_path__ + "img/green_diode.5eec3468.png";